'use client';

import { CookieBanner } from '@/components/cookie-banner';

export function CookieConsentProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <CookieBanner />
    </>
  );
}
